if (!customElements.get('sbs-mobile-menu')) {
  customElements.define('sbs-mobile-menu', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-menu-language]')) event.target.form.submit();
      });
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-open-panel]');
        const back = event.target.closest('[data-menu-back]');
        if (!opener && !back) return;
        this.querySelector('[data-menu-root]').hidden = !!opener;
        this.querySelectorAll('[data-menu-panel]').forEach(panel => {
          panel.hidden = !opener || panel.dataset.menuPanel !== opener.dataset.openPanel;
        });
        this.querySelectorAll('[data-open-panel]').forEach(button => button.setAttribute('aria-expanded', String(button === opener)));
        if (opener) {
          this.lastOpener = opener;
          this.querySelector('[data-menu-panel]:not([hidden]) [data-menu-back]').focus();
        } else this.lastOpener?.focus();
        this.closest('.main-menu__content').scrollTop = 0;
      });
    }
  });
}
